// Shape for useScanReportsTableInfinite — infinite query with pages
export const MOCK_SCAN_REPORTS_INFINITE = {
  pages: [
    {
      count: 3,
      total_pages: 1,
      current_page: 1,
      next: null,
      previous: null,
      results: [
        {
          id: 'mock-scan-report-1',
          seed: 'example.com',
          profile: 'Full Scan',
          status: 'done',
          start_time: '2024-01-15T10:00:00Z',
          end_time: '2024-01-15T10:45:00Z',
          created_at: '2024-01-15T10:00:00Z',
        },
        {
          id: 'mock-scan-report-2',
          seed: 'acme.io',
          profile: 'Quick Scan',
          status: 'done',
          start_time: '2024-01-14T08:00:00Z',
          end_time: '2024-01-14T08:20:00Z',
          created_at: '2024-01-14T08:00:00Z',
        },
        {
          id: 'mock-scan-report-3',
          seed: 'example.com',
          profile: 'SSL Audit',
          status: 'done',
          start_time: '2024-01-12T14:00:00Z',
          end_time: '2024-01-12T14:30:00Z',
          created_at: '2024-01-12T14:00:00Z',
        },
      ],
    },
  ],
  pageParams: [1],
}
